import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';

export class VendorMissingBillsResultDto {
    vendorAccountId: number;
    communityVendorId: number;
    communityId: number;
    community: string;
    vendor: string;
    accountNumber: string;

    @Type(() => Date)
    missingInvoiceDate: Date;

    @Type(() => Date)
    originalInvoiceDate: Date;

    dayMissing: number;
    workflowMissingBillQueueId: number;
    workflowId: number;
    hasNotes: boolean;
    frequency: number;
    status: string;
    isResolved: boolean;
    dateAdded: string;
    eftActive: boolean;
    invoicesForAccountCount: number;

    @Type(() => UserNameDisplayResultDto)
    lastModifiedBy: UserNameDisplayResultDto;

    @Type(() => Date)
    lastModifiedDate: Date;

    possibleResolvedByWorkflowId: number;
    possibleResolvedByStatus: string;
    accountActive: boolean;
    location: string;

    @Type(() => UserNameDisplayResultDto)
    accountant: UserNameDisplayResultDto;

    @Type(() => UserNameDisplayResultDto)
    dcam: UserNameDisplayResultDto;

    @Type(() => UserNameDisplayResultDto)
    cam: UserNameDisplayResultDto;

    @Type(() => Date)
    contractStartDate: Date;

    vendorCode: string;
    name: string;

    get lastModifiedByDisplayText(): string {
        return Utils.notNullAndDefined(this.lastModifiedBy) ? this.lastModifiedBy.displayName : '';
    }

    get accountantDisplayText(): string {
        return Utils.notNullAndDefined(this.accountant) ? this.accountant.displayName : '';
    }

    get dcamDisplayText(): string {
        return Utils.notNullAndDefined(this.dcam) ? this.dcam.displayName : '';
    }

    get camDisplayText(): string {
        return Utils.notNullAndDefined(this.cam) ? this.cam.displayName : '';
    }
}
